module.exports = __webpack_public_path__ + "static/media/newCity.b60d20b9.jpg";